"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextArea = _interopRequireDefault(require("../TextArea"));

var _CharacterCounter = _interopRequireDefault(require("../../components/CharacterCounter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A textarea component.
 */
var TextAreaWithCounter = /*#__PURE__*/function (_React$Component) {
  _inherits(TextAreaWithCounter, _React$Component);

  var _super = _createSuper(TextAreaWithCounter);

  function TextAreaWithCounter(props) {
    var _this;

    _classCallCheck(this, TextAreaWithCounter);

    _this = _super.call(this, props);
    _this.state = {
      counterValue: _this.props.max
    };
    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TextAreaWithCounter, [{
    key: "_handleChange",
    value: function _handleChange(event) {
      if (!!this.props.max && event.target.value.length >= 0) {
        this.setState({
          counterValue: this.props.max - event.target.value.length
        });
      }

      this.props.onChange(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          counterPrefix = _this$props.counterPrefix,
          counterA11yPrefix = _this$props.counterA11yPrefix,
          counterSuffix = _this$props.counterSuffix,
          counterA11ySuffix = _this$props.counterA11ySuffix,
          otherProps = _objectWithoutProperties(_this$props, ["counterPrefix", "counterA11yPrefix", "counterSuffix", "counterA11ySuffix"]);

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "text-area-with-counter"
      }, /*#__PURE__*/_react.default.createElement(_TextArea.default, _extends({}, otherProps, {
        onChange: this._handleChange,
        footer: /*#__PURE__*/_react.default.createElement(_CharacterCounter.default, {
          value: this.state.counterValue,
          prefix: counterPrefix,
          a11yPrefix: counterA11yPrefix,
          suffix: counterSuffix,
          a11ySuffix: counterA11ySuffix
        })
      })));
    }
  }]);

  return TextAreaWithCounter;
}(_react.default.Component);

TextAreaWithCounter.propTypes = {
  max: _propTypes.default.number.isRequired,
  onChange: _propTypes.default.func.isRequired,
  counterPrefix: _propTypes.default.string,
  counterA11yPrefix: _propTypes.default.string,
  counterSuffix: _propTypes.default.string,
  counterA11ySuffix: _propTypes.default.string
};
TextAreaWithCounter.defaultProps = {
  counterPrefix: undefined,
  counterA11yPrefix: undefined,
  counterSuffix: undefined,
  counterA11ySuffix: undefined
};
var _default = TextAreaWithCounter;
exports.default = _default;
//# sourceMappingURL=TextAreaWithCounter.js.map